import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useUser, User } from "@/contexts/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Title = () => {
  const { t } = useTranslation();
  const { user, login } = useUser();
  const [selectedBranch, setSelectedBranch] = useState<any>(null);

  useEffect(() => {
    setSelectedBranch(user?.selectedBranch || null);
  }, [user]);

  const handleDeselectBranch = () => {
    if (user) {
      const updatedUserData: User = {
        ...user,
        selectedBranch: null,
      };
      login(updatedUserData);
    }
  };

  return (
    <div
      className="mb-8"
      style={{
        transition: "transform 0.3s",
      }}
    >
      <div className="mb-4 flex items-center justify-between">
        {selectedBranch && (
          <button
            className="flex items-center rounded-lg border-2 border-red-500 px-2 py-1 text-xs text-red-500 sm:px-4 sm:py-2 sm:text-base"
            onClick={handleDeselectBranch}
          >
            <span className="mr-1 sm:mr-2">{selectedBranch.name}</span>
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-white sm:h-5 sm:w-5">
              <FontAwesomeIcon icon={faTimes} />
            </span>
          </button>
        )}
        <Link
          to="/branches/add"
          className="rounded-full bg-red-500 px-2 py-1 text-xs font-bold text-white sm:px-4 sm:py-2 sm:text-base"
        >
          {t("back.management.dashboard.branch.addnewbranch")}
        </Link>
      </div>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800 lg:text-4xl">
          {`${t("back.management.dashboard.title")} ${user?.first_name} ${
            user?.last_name
          }`}
        </h1>
      </div>
      <p className="text-lg text-gray-600 lg:text-xl">
        {t("back.management.dashboard.subtitle")}
      </p>
    </div>
  );
};

export default Title;
